module.exports = __webpack_public_path__ + "images/emoji/small_red_triangle.849c371e0a0a24491822.png";